import { render, staticRenderFns } from "./NewsFullscreen.vue?vue&type=template&id=5b8519bf&scoped=true"
import script from "./NewsFullscreen.vue?vue&type=script&lang=js"
export * from "./NewsFullscreen.vue?vue&type=script&lang=js"
import style0 from "./NewsFullscreen.vue?vue&type=style&index=0&id=5b8519bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8519bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b8519bf')) {
      api.createRecord('5b8519bf', component.options)
    } else {
      api.reload('5b8519bf', component.options)
    }
    module.hot.accept("./NewsFullscreen.vue?vue&type=template&id=5b8519bf&scoped=true", function () {
      api.rerender('5b8519bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/News/NewsFullscreen.vue"
export default component.exports